define('cartware/components/Utilities',[
	"lodash"
], function(
	_
) {
	return {
		getPath: function getPath (obj, ks) {
			if (typeof ks == "string") ks = ks.split(".");

			// If we have reached an undefined property
			// then stop executing and return undefined
			if (obj === undefined) return void 0;

			// If the path array has no more elements, we've reached
			// the intended property and return its value
			if (ks.length === 0) return obj;

			// If we still have elements in the path array and the current
			// value is null, stop executing and return undefined
			if (obj === null) return void 0;

			return getPath(obj[_.first(ks)], _.rest(ks));
		}
	}
});
